/* eslint-disable @nx/enforce-module-boundaries */
import { useEffect, useContext, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  HStack,
  Text,
  Box,
  FormControl,
  FormLabel,
  Textarea,
  FormHelperText,
  FormErrorMessage,
} from '@mybridge/ui';
import { MyNetworkContext } from 'v4/components/network/context';
import { CheckGreen } from '@mybridge/icons';
import { getUserFullName } from 'v4/lib/commons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

const MoreSuggestionsModal = () => {

  const { suggestionType, moreSuggestionModalDisc } =
    useContext(MyNetworkContext);
  const { t } = useTranslator();

  return (
    <Modal {...moreSuggestionModalDisc} isCentered size="xl3">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontWeight="600" fontSize="20px">
          {t('profileNetwork.peopleYouMayKnowFrom') || "People you may know from"} Stanford University
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          
        </ModalBody>
       
      </ModalContent>
    </Modal>
  );
};

export default MoreSuggestionsModal;
